import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist/index.js';
import { DepositShareType, } from '@debbie/common/dist/economy/billing/organize.js';
import { getBillingVoucherIdsFromDepositShare } from '@debbie/common/dist/economy/billing/organize.js';
import { CaseVoucherSource } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { sortBy } from '@debbie/common/dist/economy/helpers/utils.js';
import * as billingAPI from '@debbie/cortex/dist/api/billing.js';
import * as billingVouchersAPI from '@debbie/cortex/dist/api/billing-vouchers.js';
import { billingsEntity } from '@debbie/cortex/dist/billings/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import q from '@debbie/cortex/dist/query.js';
import { Header, Table, CasePreview, Badge, Money, ButtonGroup, Button, CaseStatus, } from '..//index.js';
import THEME from '../../theme.js';
import GitMerge from '../Icons/GitMerge.js';
import BillingReasons from './BillingReasons.js';
import PaymentType from './case-vouchers/PaymentType.js';
import { billingVouchersEntity } from '@debbie/cortex/dist/billing-vouchers/index.js';
const DepositShareCmp = (props) => {
    const { deposit, share, info, overpayments, vat, type } = props.depositShare;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loadingBilling, setLoadingBilling] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const caseId = props.depositShare.share[0]?.collectionCommissionVouchers[0]?.caseId ||
        props.depositShare.share[0]?.payoutVouchers[0]?.caseId;
    const billingId = props.depositShare.share[0]?.collectionCommissionVouchers[0]?.billingId ||
        props.depositShare.share[0]?.payoutVouchers[0]?.billingId;
    return (React.createElement("div", { style: {
            borderLeft: props.highlightCase
                ? `3px solid ${THEME.COLOR_ACCENT}`
                : undefined,
            paddingLeft: props.highlightCase ? `10px` : undefined,
        } },
        React.createElement("div", null, deposit && (React.createElement(React.Fragment, null,
            React.createElement(Header, { size: "3" },
                deposit.date &&
                    moment(deposit.date)
                        .locale(lang.is.currently.slice(0, 2))
                        .format('L'),
                ' ',
                lang.depositShareType[type] || lang.invoice.deposit,
                deposit.id ? ` - ${deposit.id}` : '',
                deposit?.text ? ` (${deposit.text})` : ''),
            React.createElement(Header, { size: "4" },
                React.createElement(PaymentType, { paymentType: deposit?.paymentType }),
                ' ',
                deposit?.state && lang.caseVoucherStates[deposit.state],
                ' ',
                info?.debtorNames || info?.customerReferenceId
                    ? ` ${info?.debtorNames || ''}${info?.customerReferenceId
                        ? ` (${info?.customerReferenceId})`
                        : ''}`
                    : '',
                React.createElement("div", { style: { marginTop: '20px' } },
                    info?.caseSequentialId && (React.createElement(CasePreview, { caseId: info.caseSequentialId, tooltipToLeft: true })),
                    ' ',
                    info?.caseStatus && React.createElement(CaseStatus, { status: info.caseStatus }),
                    ' '))))),
        deposit?.source === CaseVoucherSource.Creditor && (React.createElement("p", null,
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.invoice.creditorDeposit))),
        deposit?.caseVoucherId && site === Site.Caseworker && !props.demo && (React.createElement(BillingReasons, { depositCaseVoucherId: deposit.caseVoucherId, billingId: billingId || undefined, caseId: caseId })),
        React.createElement(Table, { zebra: true, sumRow: true, style: { marginBottom: `${THEME.GRID_SPACING}px` } },
            React.createElement("tr", null,
                React.createElement("th", null, lang.clientBilling.voucherType),
                props.depositShare.type === DepositShareType.Deposit && (React.createElement("th", { style: { textAlign: 'right', width: '18%' } }, lang.clientBilling.paid)),
                React.createElement("th", { style: { textAlign: 'right', width: '18%' } }, lang.clientBilling.collector),
                React.createElement("th", { style: { textAlign: 'right', width: '18%' } }, lang.clientBilling.creditor)),
            share
                .sort(sortBy((a, b) => ((a.caseVoucher?.voucherTypeId || '') <
                (b.caseVoucher?.voucherTypeId || '')
                ? 1
                : 0) -
                ((a.caseVoucher?.voucherTypeId || '') >
                    (b.caseVoucher?.voucherTypeId || '')
                    ? 1
                    : 0), (a, b) => (a.caseVoucher ? new Date(a.caseVoucher.date).getTime() : 0) -
                (b.caseVoucher ? new Date(b.caseVoucher.date).getTime() : 0)))
                .map((s, index) => {
                return (React.createElement("tr", { key: (s.caseVoucher?.voucherTypeId || '') +
                        (deposit && deposit.caseVoucherId) +
                        index },
                    React.createElement("td", null,
                        s.caseVoucher?.voucherTypeId &&
                            lang.economyVoucherTypeLabels[s.caseVoucher?.voucherTypeId],
                        s.caseVoucher?.referenceId && (React.createElement("b", null,
                            " ",
                            s.caseVoucher?.referenceId)),
                        ' ',
                        s.caseVoucher?.source === CaseVoucherSource.Creditor && (React.createElement(GitMerge, { style: {
                                transform: 'rotate(-90deg)',
                                margin: '0.1em 0 -0.1em',
                            } }))),
                    props.depositShare.type === DepositShareType.Deposit && (React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: s.collectionCommissionBalance + s.payoutBalance }))),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: s.collectionCommissionBalance })),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: s.payoutBalance }))));
            }),
            overpayments &&
                !!overpayments.reduce((acc, s) => acc + s.amount, 0) && (React.createElement("tr", { style: {
                    opacity: 0.65,
                } },
                React.createElement("td", null, lang.invoice.overpayment),
                props.depositShare.type === DepositShareType.Deposit && (React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: overpayments.reduce((acc, s) => acc + s.amount, 0) }))),
                React.createElement("td", null),
                React.createElement("td", null))),
            !!vat && !!vat.reduce((acc, s) => acc + s.amount, 0) && (React.createElement("tr", { style: {
                    opacity: 0.65,
                    fontSize: '0.9em',
                    fontWeight: 900,
                } },
                React.createElement("td", null, lang.invoice.vat),
                props.depositShare.type === DepositShareType.Deposit && (React.createElement("td", { style: { textAlign: 'right' } })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: vat.reduce((acc, s) => acc + s.amount, 0) })),
                React.createElement("td", null))),
            React.createElement("tr", null,
                React.createElement("td", null),
                props.depositShare.type === DepositShareType.Deposit && (React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: share.reduce((acc, s) => acc + s.collectionCommissionBalance + s.payoutBalance, 0) + (overpayments || []).reduce((acc, s) => acc + s.amount, 0) }))),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: share.reduce((acc, s) => acc + s.collectionCommissionBalance, 0) + (vat || []).reduce((acc, s) => acc + s.amount, 0) })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: share.reduce((acc, s) => acc + s.payoutBalance, 0) })))),
        React.createElement(ButtonGroup, null,
            props.billingSelector && (React.createElement(Button, { size: "small", loading: loadingBilling, onClick: async () => {
                    if (props.billingSelector) {
                        setLoadingBilling(true);
                        try {
                            await billingAPI.createBillingCollection({
                                newBillings: [
                                    {
                                        ...props.billingSelector,
                                        billingVoucherIds: getBillingVoucherIdsFromDepositShare(props.depositShare),
                                    },
                                ],
                            });
                            q.invalidate(keys.write.create(billingsEntity));
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                        setLoadingBilling(false);
                    }
                } },
                lang.billing.bill,
                " ",
                deposit?.id)),
            props.billingSelector && (React.createElement(Button, { size: "small", loading: deleting, onClick: async () => {
                    setDeleting(true);
                    if (confirm(lang.billing.deleteApproval)) {
                        const billingVoucherIds = getBillingVoucherIdsFromDepositShare(props.depositShare);
                        try {
                            await billingVouchersAPI.del(billingVoucherIds);
                            q.invalidate(billingVoucherIds.flatMap((id) => keys.write.modify(billingVouchersEntity, id)));
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                    }
                    setDeleting(false);
                }, theme: "dangerous" },
                lang.billing.delete,
                " ",
                deposit?.id)))));
};
export default DepositShareCmp;
//# sourceMappingURL=DepositShare.js.map